// Copyright (c) 2016 Deere & Company

import {isDaysToDisplayValid} from '../../shared/validations/days-to-display';

export const isPartRequestStatusValid = selectedStatuses => selectedStatuses.length > 0;

export const isPartRequestDaysToDisplayValid = days => isDaysToDisplayValid(days);

export const isFormValid = partRequestSettings =>
isPartRequestStatusValid(partRequestSettings.status.selectedStatuses) &&
isPartRequestDaysToDisplayValid(partRequestSettings.numberOfDays);



// WEBPACK FOOTER //
// ./src/user/part-returns-settings/services/form-validation.js